<template>
    <div class="r">
        <div class="r-title">确定房号（{{ title }}）</div>
        <Tree
            class="t-tree"
            :data="treeList"
            showCheckbox
            @on-check-change="checkItem"
        />
        <!-- 提示信息——确定删除 -->
        <confirm
            :text="modalMsg"
            v-model="confirmShowDelete"
            @closeModal="closeModalDelete"
            @confirmModal="confirmModalDelete"
        />
    </div>
</template>

<script>
import { assetsTreeList, assetsHouseList, delBatch } from '@/api/assets'

import Confirm from '_v/components/confirm'

export default {
    name: 'RoomBatchDeleteForm',
    components: { Confirm },
    props: {
        parkId: {
            type: [String, Number],
            default: '',
        },
        floorId: {
            type: [String, Number],
            default: '',
        },
        floorNum: {
            type: [String, Number],
            default: '',
        },
        floorName: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            filter: {
                parkId: this.parkId, // 园区/社区
                floorId: this.floorId, // 楼栋id
                floorNum: this.floorNum, // 楼层
                pageSize: 9999,
            },
            treeList: [],
            chooseHouseIdList: [],
            title: '',
            confirmShowDelete: false,
            houseIds: '',
            modalMsg: '',
        }
    },
    watch: {
        chooseHouseIdList: {
            handler(val) {
                const btn = this.$modal.normalBtns[0]
                btn.disabled = !val.length
            },
            immediate: true,
            deep: true,
        },
    },

    inject: {
        $modal: {
            default: null,
        },
    },
    created() {},
    mounted() {
        // 预加载
        this.$modal.beforeEnter((next) => {
            Promise.all([assetsHouseList(this.filter)])
                .then((args) => {
                    var [view] = args
                    this.formateView(view?.data?.page?.list)
                })
                .finally(() => {
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            this.confirmShowDelete = true
            this.modalMsg = '删除后房间需要重新添加，是否确定？'
            this.houseIds = this.chooseHouseIdList.join(',')
            options.closeModal = false
            next()
        })
    },
    methods: {
        formateView(list) {
            list = list || []
            const firstHouse = list[0],
                treeList = []
            // 设置title
            if (firstHouse) {
                this.title = firstHouse.parkName + firstHouse.floorName
            }
            // 获取treeList
            list.forEach((v) => {
                v.pid = v.floorNum
                v.title = v.houseNum
                v.children = []
                v.spread = true
                v.isEnd = true
                v.disabled = !!(v.contractStatus || v.houseStatus != '1')
                const item = treeList.find((p) => p.id === v.pid)
                if (item) {
                    item.children.push(v)
                } else {
                    treeList.push({
                        id: v.pid,
                        title: v.floorNum + '层',
                        children: [v],
                        expand: true,
                        disabled: true,
                    })
                }
            })
            treeList.forEach((v) => {
                v.children.forEach((p) => {
                    if (!p.disabled) {
                        v.disabled = false
                    }
                })
            })
            this.treeList = treeList
        },
        checkItem(arr) {
            this.chooseHouseIdList = arr.filter((v) => v.isEnd).map((v) => v.id)
        },
        closeModalDelete() {
            this.confirmShowDelete = false
        },
        confirmModalDelete() {
            delBatch(this.houseIds).then(() => {
                this.$emit('search')
                this.$modal.onClose()
                this.$Message.success(this.$t('tips.delete.success'))
            })
        },
    },
}
</script>

<style lang="less" scoped>
.r {
    &-title {
        font-size: 16px;
    }
}
</style>
